module.exports = __webpack_public_path__ + "static/media/14-50.c31e4b53.svg";